// todo unify rest of codebase to use the functions in this file

export const currentTimeStamp = () => {
  // should this use moment?
  return new Date().toISOString().replace(/[:.]/g, '-');
};

export const downloadCSV = (data, headers, fileName) => {
  let csvContent = headers.join(',') + '\n';

  data.forEach((item) => {
    const row = headers.map((header) => {
      const value = String(item[header] || '');

      // comma, quote, or newline
      if (/[,"\n]/.test(value)) {
        return `"${value.replace(/"/g, '""')}"`;
      }
      return value;
    });

    csvContent += row.join(',') + '\n';
  });

  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });

  downloadBlob(blob, fileName);
};

export const downloadJSON = (data, fileName) => {
  const jsonString = JSON.stringify(data, null, 2);
  const blob = new Blob([jsonString], { type: 'application/json' });

  downloadBlob(blob, fileName);
};

export const downloadBlob = (blob, fileName) => {
  const url = URL.createObjectURL(blob);

  try {
    const link = document.createElement('a');
    link.setAttribute('href', url);
    link.setAttribute('download', fileName);

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } finally {
    // avoid memory leak
    URL.revokeObjectURL(url);
  }
};
